
import FormatterService from "@/service/FormatterService";
import ShareService from '@/service/ShareService';

    export default {

        name: 'Quote',

        props: {
            share: Object,
            interval: {
                type: String,
                default: 'day'
            }
        },

        data() {
            return {
                format: new FormatterService(),
                prevSharePrice: null,
                isLoading: false,
                shareQuotesPrice: {},
            }
        },

        computed: {
            quoteMetaText() {
                let text = ''
                if (this.share.micNiceName) {
                    text += this.share.micNiceName
                }
                if (this.share.mic) {
                    text += ` (${this.share.mic})`
                }

                return text
            }
        },

        methods: {
            getChangeClass() {
                let className = 'quote__price--change'
                if(this.prevSharePrice < this.share.price) className += ' quote__price--change-positive'
                if(this.prevSharePrice > this.share.price) className += ' quote__price--change-negative'
                return className
            },

            async fetchShareQuotesPrice() {
                this.isLoading = true;
                if (!this.share || !this.share.isin || !this.interval || !this.share.primaryMarketCurrency) {
                    return;
                }
                try {
                    const data = await this.shareService.getShareQuotesPrice(this.share.isin, this.interval, this.share.primaryMarketCurrency);
                    this.shareQuotesPrice = data;
                } catch (error) {
                    this.shareQuotesPrice = {};
                }
                this.isLoading = false;
            },
        },

        watch: {
            'share.isin'() {
                this.prevSharePrice = this.share.price
                this.fetchShareQuotesPrice();
            },
            interval() {
                this.fetchShareQuotesPrice();
            },
        },

        created() {
            this.shareService = new ShareService(this.$axios);

            this.fetchShareQuotesPrice();

            if (this.share.price <= 0) {
                this.marketStatus = null
            } else if (!this.share.primaryMarketOpen) {
                this.marketStatus = this.$t('component.portfolio.quote.marketClosed')
                if (this.share.primaryMarketMic != this.share.mic) {
                    this.marketStatus += this.$t('component.portfolio.quote.lastTradedWorldwide')
                }
            } else {
                if (this.share.primaryMarketMic == this.share.mic) {
                    this.marketStatus = this.$t('component.portfolio.quote.homeMarket')
                } else {
                    this.marketStatus = this.$t('component.portfolio.quote.lastTradedWorldwide')
                }
            }
        }
    }
